<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="addPointsDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Add Points</v-card-title
                    >
                </v-layout>
                <div
                    class="my-2 font-weight-medium text-danger"
                    v-if="!selected.length"
                >
                    NO STUDENTS SELECTED
                </div>
                <div class="my-2 font-weight-medium" v-if="selected.length">
                    SELECTED:
                </div>
                <div style="overflow-y: auto; height: 200px">
                    <div v-for="(student, index) in selected">
                        <div class="mb-2">
                            {{ student.hebName + " " + student.class }}
                        </div>
                        <v-divider
                            class="my-2"
                            v-if="index + 1 < selected.length"
                        ></v-divider>
                    </div>
                </div>
                <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="false"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class=""
                            v-model="scanDate"
                            :value="scanDate"
                            label="Date"
                            readonly
                            ref="scanDate"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="scanDate"></v-date-picker>
                </v-menu>

                <v-text-field
                    class=""
                    v-model="addPoints"
                    label="Points"
                    type="number"
                    ref="addPoints"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-select
                    :items="pointTypes"
                    v-model="pointsType"
                    label="Points Type"
                    ref="pointsType"
                    :rules="[rules.required]"
                ></v-select>
                <v-text-field
                    class=""
                    v-model="addPointsNote"
                    label="Note"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addPointsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="savePoints()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="reportAbsentDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Report Absent</v-card-title
                    >
                </v-layout>
                <div
                    class="my-2 font-weight-medium text-danger"
                    v-if="!selected.length"
                >
                    NO STUDENTS SELECTED
                </div>
                <div class="my-2 font-weight-medium" v-if="selected.length">
                    SELECTED:
                </div>
                <div style="overflow-y: auto; height: 200px">
                    <div v-for="(student, index) in selected">
                        <div class="mb-2">
                            {{ student.hebName + " " + student.class }}
                        </div>
                        <v-divider
                            class="my-2"
                            v-if="index + 1 < selected.length"
                        ></v-divider>
                    </div>
                </div>
                <v-menu
                    v-model="absentDatePickerMenu"
                    :close-on-content-click="false"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class=""
                            v-model="absentDate"
                            :value="absentDate"
                            label="Absent Date"
                            readonly
                            ref="absentDate"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="absentDate"></v-date-picker>
                </v-menu>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="reportAbsentDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveAbsentReport()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
                <div v-if="studentsPresent.length" class="text-danger">
                    <div class="font-weight-medium mb-2">
                        The below selected students are already present
                    </div>

                    <div v-for="(student, index) in studentsPresent">
                        <div class="mb-2">
                            {{ student.hebName + " " + student.class }}
                        </div>
                        <v-divider
                            class="my-2"
                            v-if="index + 1 < studentsPresent.length"
                        ></v-divider>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Student Attendance Report",
        url: "",
        forDate: "",
        actions: [],
        selected: [],
        datePickerMenu: false,
        addPointsDialog: false,
        scanDate: "",
        processing: false,
        addPoints: "",
        addPointsNote: "",
        pointsType: "Used",
        pointTypes: ["Earned", "Used"],
        reportAbsentDialog: false,
        absentDatePickerMenu: false,
        absentDate: "",
        studentsPresent: [],

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "PRESENT":
                            return "mdi-check-circle";
                        case "ABSENT":
                            return "mdi-alpha-x-box";
                        case "MISSING":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "PRESENT":
                            return "success";
                        case "ABSENT":
                            return "#FFA726";
                        case "MISSING":
                            return "#f35123";
                        default:
                            return "#fdb400";
                    }
                },
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Family ID",
                //link: "AccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Family Name",
                field: "familyName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scan Date",
                field: "scanDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Number",
                field: "cardNum",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points Balance",
                field: "pointsBalance",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        async beforeSetupGrid() {
            this.forDate = toISOLocal(new Date(moment())).substr(0, 10);

            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "For Date",
                type: "datepicker",
                value: this.forDate,
                action: this.onDateChanged,
                //align: "right",
            });

            this.actions.push({
                text: "Add Points",
                action: this.openPointsDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Report Absent",
                action: this.openReportAbsentDialog,
                showOnSelection: true,
            });

            this.url =
                "studentAttendanceReport?forDate=" +
                this.forDate +
                (this.userBranch ? "&branch=" + this.userBranch : "&branch=");
        },
        onDateChanged(value) {
            this.forDate = value;
            this.url =
                "studentAttendanceReport?forDate=" +
                this.forDate +
                (this.userBranch ? "&branch=" + this.userBranch : "&branch=");

            this.$refs.grid.reloadDataSource(this.url);
        },
        openPointsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.addPoints = "";
            this.scanDate = this.forDate;
            this.addPointsDialog = true;
        },
        openReportAbsentDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.absentDate = this.forDate;
            this.reportAbsentDialog = true;
        },
        async savePoints() {
            if (
                !this.$refs.addPoints.validate(true) ||
                !this.$refs.pointsType.validate(true)
            )
                return;

            if (!this.scanDate) {
                return this.$notify({
                    text: "Missing Date",
                    group: "notification",
                    type: "success",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/studentAttendanceCards/AddScans",
                    this.selected.map((student) => ({
                        cardNum: student.cardNum,
                        studentID: student.studentID,
                        regID: student.regID,
                        points: this.addPoints,
                        enteredBy: this.$store.state.authentication.user,
                        note: this.addPointsNote,
                        pointsType: this.pointsType,
                        scanDate: moment(this.scanDate).format(
                            "YYYY-MM-DD HH:mm:ss",
                        ),
                    })),
                );

                this.processing = false;
                this.addPointsDialog = false;
                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Points Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async saveAbsentReport() {
            this.studentsPresent = [];

            if (!this.absentDate) {
                return this.$notify({
                    text: "Missing Absent Date",
                    group: "notification",
                    type: "success",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/studentAttendanceCards/reportAbsent",
                    {
                        students: this.selected,
                        user: this.$store.state.authentication.user,
                        date: moment(this.absentDate).format("YYYY-MM-DD"),
                    },
                );

                if (response.failed) {
                    this.studentsPresent = response.studentsPresent;
                    this.processing = false;

                    return;
                }

                this.processing = false;
                this.reportAbsentDialog = false;
                this.studentsPresent = [];
                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Absent Reported",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
